// extracted by mini-css-extract-plugin
module.exports = {"main":"swatch-module--main--1hvg3","small":"swatch-module--small--2nnj1 swatch-module--main--1hvg3"};